/** UUID v4 with a fallback for environments without crypto.randomUUID (older
 *  targets, some test runners). Used for correlation and idempotency headers. */
export function newRequestId(): string {
  const c = globalThis.crypto;
  // DOM lib types crypto as always-defined; the check is real at runtime in
  // older environments without it, which is exactly what this fallback is for.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = Math.floor(Math.random() * 16);
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
